import { render } from "./Buttons.vue?vue&type=template&id=0fc0fcf2"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"
script.render = render

export default script